import styled from 'styled-components';
import { Container } from '../../styles/sharedComponents';

export const FooterSection = styled.footer<{ $isVisible?: boolean }>`
  padding: 80px 0 40px;
  background: #0a0a0a;
  position: relative;
  overflow: hidden;
  margin-top: 0;

  opacity: ${props => props.$isVisible ? 1 : 0};
  transform: translateY(${props => props.$isVisible ? '0' : '30px'});
  transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);

  @media (max-width: 768px) {
    padding: 60px 0 32px;
  }
`;

export const FooterContent = styled(Container)`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: 48px;
  margin-bottom: 48px;

  @media (max-width: 968px) {
    grid-template-columns: 1fr 1fr;
    gap: 32px;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 24px;
    text-align: center;
  }
`;

export const FooterBrand = styled.div`
  h3 {
    font-size: 1.5rem;
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 16px;
    background: linear-gradient(135deg, #ff4444, #ff6b6b);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  p {
    color: #a1a1aa;
    line-height: 1.6;
    margin-bottom: 24px;
  }
`;

export const FooterColumn = styled.div`
  h4 {
    font-size: 1rem;
    font-weight: 600;
    color: #ffffff;
    margin-bottom: 16px;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  li {
    margin-bottom: 8px;
  }

  a {
    color: #a1a1aa;
    text-decoration: none;
    transition: color 0.3s ease;
    font-size: 0.9rem;

    &:hover {
      color: #ff4444;
    }
  }
`;

export const FooterBottom = styled.div`
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  padding-top: 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
    text-align: center;
  }
`;

export const FooterCopyright = styled.p`
  color: #71717a;
  font-size: 0.9rem;
  margin: 0;
`;

export const FooterSocials = styled.div`
  display: flex;
  gap: 16px;
`;

export const SocialLink = styled.a`
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #a1a1aa;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 68, 68, 0.1);
    border-color: rgba(255, 68, 68, 0.3);
    color: #ff4444;
    transform: translateY(-2px);
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;
